import { render, staticRenderFns } from "./SenderNoticeDetails.vue?vue&type=template&id=21bea57f&scoped=true&"
import script from "./SenderNoticeDetails.vue?vue&type=script&lang=js&"
export * from "./SenderNoticeDetails.vue?vue&type=script&lang=js&"
import style0 from "./SenderNoticeDetails.vue?vue&type=style&index=0&id=21bea57f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bea57f",
  null
  
)

export default component.exports